module.exports = __webpack_public_path__ + "img/passione.6dcc595f.jpg";